import { useQuery } from "@tanstack/react-query";
import { GET } from "../Controllers/ApiControllers";
import admin from "../Controllers/admin";
import { useSelectedClinic } from "../Context/SelectedClinic";

const usePathologyData = (active) => {
  const { selectedClinic } = useSelectedClinic();

  const fetchPathologyData = async () => {
    let url = `get_pathologist?`;
    if (active) {
      url += "&active=1";
    }
    const res = await GET(admin.token, url);
    return res.data;
  };

  const {
    isLoading: pathologyLoading,
    data: pathologyData,
    error: pathologyError,
  } = useQuery({
    queryKey: ["pathology", selectedClinic?.id],
    queryFn: fetchPathologyData,
  });

  return { pathologyData, pathologyLoading, pathologyError };
};

export default usePathologyData;
